import React from 'react';
import { PropTypes } from 'prop-types';
import '../styles/classicscreen.scss';

function ClassicScreen(props) {
  const { children } = props;

  const print = () => {
    const win = window.open('', 'PRINT', 'height=400,width=600');

    win.document.write(`<pre>${children}</pre>`);
    win.document.close();
    win.focus();
    win.print();
    win.close();

    return true;
  };

  return (
    <div className="classic-wrapper">
      <div className="classic-text">
        {children}
      </div>
      <div className="print-icon" onClick={print} role="presentation">
        <i className="zmdi zmdi-print" />
      </div>
    </div>
  );
}

ClassicScreen.propTypes = {
  children: PropTypes.string,
};

export default ClassicScreen;

